import googleFill from "@iconify/icons-eva/google-fill";
import { Icon } from "@iconify/react";
// material
import { Button, Stack, Typography, Box } from "@material-ui/core";
import { styled, alpha } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { loginWithGoogle } from "../../firebaseConfig";
import { useNatively } from "hooks/useNatively";

// ----------------------------------------------------------------------

const GoogleButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#ffffff",
  border: `1px solid ${alpha(theme.palette.grey[300], 0.8)}`,
  color: theme.palette.text.primary,
  fontWeight: 500,
  padding: theme.spacing(1.5, 3),
  borderRadius: theme.spacing(1),
  textTransform: "none",
  fontSize: "1rem",
  transition: "all 0.2s ease-in-out",
  boxShadow: `0 2px 4px ${alpha(theme.palette.grey[900], 0.1)}`,
  "&:hover": {
    backgroundColor: "#f8f9fa",
    border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
    boxShadow: `0 4px 12px ${alpha(theme.palette.grey[900], 0.15)}`,
    transform: "translateY(-1px)"
  },
  "&:active": {
    transform: "translateY(0)"
  }
}));

const GoogleIcon = styled(Box)(({ theme }) => ({
  width: 20,
  height: 20,
  marginRight: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}));

// ----------------------------------------------------------------------

export default function AuthWithSocial() {
  const { t } = useTranslation();
  const { nativelyInfo } = useNatively();

  const handleLoginGoogle = async () => {
    try {
      await loginWithGoogle(nativelyInfo);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Stack spacing={3}>
      <GoogleButton
        fullWidth
        size="large"
        variant="outlined"
        onClick={handleLoginGoogle}
        startIcon={
          <GoogleIcon>
            <svg width="20" height="20" viewBox="0 0 24 24">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
          </GoogleIcon>
        }
      >
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {t("auth.continueWithGoogle")}
        </Typography>
      </GoogleButton>
    </Stack>
  );
}
